import { Table } from 'antd';

import { DAY_OF_WEEK } from 'app/typings/core/common/enum/dayOfWeek';

import { usePriceColumns } from './hooks/usePriceColumns';
import { usePriceDataSource } from './hooks/usePriceDataSource';

type DailyPriceConfigurationTableProps = {
  hasDayPrice: boolean;
  hasAdultChildPrice: boolean;
};

export const DailyPriceConfigurationTable = ({
  hasDayPrice,
  hasAdultChildPrice,
}: DailyPriceConfigurationTableProps) => {
  const dataSource = usePriceDataSource(hasDayPrice, hasAdultChildPrice);
  const columns = usePriceColumns(
    Object.values(DAY_OF_WEEK),
    hasDayPrice,
    hasAdultChildPrice,
    dataSource
  );

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      size="small"
      bordered
    />
  );
};
